import { date } from './index';

const joinStockEntities = (url = "") => {
  const joins = [
    "cloths",
    "sewing_accessories",
    "products",
    "cut_of_clothes",
    "stationery",
    "expendable_materials",
    "promotional_products",
    "packages",
  ];
  joins.forEach((joinName) => (url += `&join=${joinName}`));
  return url;
};

const addDateField = (body, httpMethod = 'post') => {
  const fieldName = httpMethod === 'post' ? 'created_at' : 'updated_at';
  body[fieldName] = date.getIsoString();
  return body;
};

export const httpHelper = {
  joinStockEntities,
  addDateField,
};



// WEBPACK FOOTER //
// ./src/_shared/utils/httpHelper.js